import {isEmpty} from 'lodash';
import type {Context} from '../types';

/**
 * This patch moves Ecommerce conditions from node.data.commerce.bind to node.data.dyn.bind
 */

export default (context: Context) => {
  const {
    node: {
      jsonNode: {data: nodeData = {}, _id},
    },
  } = context;

  const commerceData = nodeData.commerce;
  const commerceCondition = commerceData && commerceData.condition;

  const needed = commerceCondition;

  return {
    needed,
    logData: {
      msg: 'Moving commerce condition from `node.data.commerce.condition` to `node.data.dyn.condition`',
      meta: {
        nodeId: _id,
      },
    },
    apply: () => {
      const hasCorruptCommerceCondition =
        !commerceCondition.class ||
        !commerceCondition.class.false ||
        !commerceCondition.class.false['w-condition-invisible'] ||
        !commerceCondition.class.false['w-condition-invisible'].fields ||
        isEmpty(commerceCondition.class.false['w-condition-invisible'].fields);

      if (hasCorruptCommerceCondition) {
        // Cannot delete nodeData.commerce.condition because:
        // • property condition is missing in undefined [1].
        // • property condition is missing in undefined [2].
        delete nodeData.commerce.condition; // eslint-disable-line webflow/no-delete
        if (isEmpty(nodeData.commerce)) {
          // eslint-disable-next-line webflow/no-delete
          delete nodeData.commerce;
        }
        return;
      }

      if (!nodeData.dyn) {
        nodeData.dyn = {};
      }

      nodeData.dyn.condition = commerceCondition;

      // Cannot delete nodeData.commerce.condition because:
      // • property condition is missing in undefined [1].
      // • property condition is missing in undefined [2].
      delete nodeData.commerce.condition; // eslint-disable-line webflow/no-delete
      if (isEmpty(nodeData.commerce)) {
        // eslint-disable-next-line webflow/no-delete
        delete nodeData.commerce;
      }
    },
  };
};
